<template>
  <nav class="sidebar bg-gray-9 shadow" :class="{ 'sidebar--open': isNavOpened }">
    <!-- only for mobile -->
    <div v-if="isNavOpened" class="d-none d-md-none d-sm-block sidebar-content-view">
      <div v-if="navOption && navOption.title" class="mt-6 pt-4 d-flex align-items-center">
        <div class="flex-grow-1">
          <span class="fa-stack fa-1x color-white font-18 mr-2 ml-1">
            <em class="fas fa-circle fa-stack-2x"></em>
            <em class="fa-stack-1x fa-inverse color-primary-4" :class="navOption.icon" />
          </span>
          <span class="color-black-1 font-16 font-weight-bold">
            {{ navOption.title }}
          </span>
        </div>
        <div class="mr-4 cursor-pointer" @click="closeNavHandler(!isNavOpened)">
          <em class="fa fa-times font-20 color-gray-13" />
        </div>
      </div>
      <component v-if="navOption && navOption.component" :is="navOption.component"></component>
    </div>
    <div :class="{ 'd-flex': isNavOpened }">
      <div class="sidebar__menu" :class="{ 'sidebar__menu--open': isNavOpened }" @click="closeNavHandler(!isNavOpened)">
        <em class="font-25" :class="{
          'fas fa-arrow-circle-left': !isNavOpened,
          'fas fa-arrow-circle-right': isNavOpened,
        }" />
      </div>
      <div class="p-3 shadow w-100 d-flex align-items-center" v-if="isNavOpened">
        <div class="flex-grow-1">
          <div v-if="navOption && navOption.title" class="d-block d-md-block d-sm-none">
            <span class="fa-stack fa-1x color-white font-20 mr-2">
              <em class="fas fa-circle fa-stack-2x"></em>
              <em class="fa-stack-1x fa-inverse color-primary-4" :class="navOption.icon" />
            </span>
            <span class="color-black-1 font-16 font-weight-bold">
              {{ navOption.title }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="vh-100 sidebar-menu-items" :class="{ 'd-flex': isNavOpened }">
      <div class="sidebar__content shadow" :class="{ 'sidebar__content--open': isNavOpened }">
        <div class="sidebar__item">
          <side-bar-item v-for="(option, index) in availableOptions" :key="`side-bar-item-${index}`" :option="option"
            @on-select="onSelectHandler(index, $event)" :selected-option="navOption" />
        </div>
      </div>
      <div class="sidebar-dynamic-content w-87">
        <component v-if="navOption && isNavOpened && navOption.component" :is="navOption.component" />
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from 'vuex';
import { name as appModuleName } from '@/store/modules/app';
import { SideBarItem } from './components';
import { name as userModuleName } from '@/store/modules/user';
import {
  ChangeStatus,
  AssignmentManagement,
  DocumentManagement,
  CommentManagement,
  History,
  StampingStatus,
} from '@/views/request/components/sidebar';
import { i18n } from '@/i18n';
import roles from '@/utils/constants/roles.js';
import requestStatus from '@/utils/constants/requestStatus.js';
export default {
  name: 'TheSideBar',
  components: {
    SideBarItem,
    ChangeStatus,
    AssignmentManagement,
    DocumentManagement,
    CommentManagement,
    History,
    StampingStatus,
  },
  watch: {
    sidebarBadgeCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.options = this.options.map((x) => ({
          ...x,
          count: this.getAssignBadgeCount(x.id, newVal),
        }));
      }
    },
  },
  data() {
    return {
      options: [
        {
          id: 1,
          icon: 'fal fa-clipboard-list',
          title: i18n.t('ChangeOfStatus'),
          component: 'ChangeStatus',
          active: false,
          count: null,
          visible: false,
        },
        {
          id: 2,
          icon: 'fal fa-user-tie',
          title: i18n.t('FnLnkAssignments'),
          component: 'AssignmentManagement',
          active: false,
          count: this.sidebarBadgeCount?.assignmentCount,
          visible: false,
        },
        {
          id: 3,
          icon: 'fal fa-folder-open',
          title: i18n.t('RequiredDocument'),
          component: 'DocumentManagement',
          active: false,
          count: this.sidebarBadgeCount?.documentCount,
          visible: false,
        },
        {
          id: 4,
          icon: 'fal fa-stamp',
          title: i18n.t('stampingStatus'),
          component: 'StampingStatus',
          active: false,
          count: null,
          visible: false, 
        },
        {
          id: 5,
          icon: 'fal fa-comment-plus',
          title: i18n.t('IssueComments'),
          component: 'CommentManagement',
          active: false,
          count: this.sidebarBadgeCount?.commentCount,
          visible: true,
        },
        {
          id: 6,
          icon: 'fal fa-clock',
          title: i18n.t('Record'),
          component: 'History',
          active: false,
          count: null,
          visible: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isNavOpened: 'getIsNavOpen',
      navOption: 'getNavOption',
    }),
    availableOptions() {
      // Find the "ChangeStatus" component object in the options array
      var changeStatusComponent = this.options.find(
        (option) => option.component === 'ChangeStatus'
      );
      console.log(this.roleName()?.toLowerCase() != roles.APPLICANT.toLowerCase())
      console.log(this.itemModel.requestStatusName);
      if (changeStatusComponent) {
        changeStatusComponent.active = this.canViewChangeStatusSideBar;
        if (this.roleName()?.toLowerCase() == roles.INVESTIGATOR?.toLowerCase()) {
          console.log("entro")
          changeStatusComponent.visible = this.itemModel.requestStatusId != requestStatus.DevueltoPorFaltaInformacion;
        }
        else {
          changeStatusComponent.visible = (this.canViewChangeStatusSideBar && this.roleName()?.toLowerCase() != roles.APPLICANT.toLowerCase()) || (this.roleName()?.toLowerCase() == roles.APPLICANT.toLowerCase() && this.itemModel.requestStatusId == requestStatus.Autorizado);
        }
      }

      // Find the "AssignmentManagement" component object in the options array
      var assignmentManagementComponent = this.options.find(
        (option) => option.component === 'AssignmentManagement'
      );

      if (assignmentManagementComponent) {
        assignmentManagementComponent.active =
          this.canViewAssignmentManagementSideBar;
        assignmentManagementComponent.visible =
          this.canViewAssignmentManagementSideBar && (this.roleName()?.toLowerCase() == roles.SUPERVISOR.toLowerCase() || this.roleName()?.toLowerCase() == roles.ADMIN.toLowerCase());
      }
      return this.options.filter((x) => x.visible);
    },
  },
  async mounted() {
    console.log("side-bar")
    console.log(this.itemModel);
  },
  methods: {
    ...mapGetters(userModuleName, {
      roleName: 'role',
    }),
    onSelectHandler(optionIndex, option) {
      this.setIsNavOpen({
        isNavOpen: true,
        navOption: option,
      });
      this.options = this.availableOptions.map((item, index) => ({
        ...item,
        active: optionIndex === index,
      }));
    },
    closeNavHandler(value) {
      if (value && !this.navOption.component) {
        this.onSelectHandler(0, this.availableOptions[0]);
      }
      this.setIsNavOpen({
        isNavOpen: value || false,
        preserveOption: true,
      });
    },
    getAssignBadgeCount(id, badgeItem) {
      switch (id) {
        case 2:
          return badgeItem.assignmentCount;
        case 3:
          return badgeItem.documentCount;
        case 4:
          return badgeItem.commentCount;
        default:
          return 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

.sidebar {
  min-width: 50px;
  max-width: 50px;
  height: 100%;
  top:0;
  // top: 140px;
  right: 0;
  overflow: hidden;
  position: fixed;
  padding-bottom: 20px;
  z-index: 100;

  &__menu {
    background: map-get($colors, 'blue-light-2');
    color: #fff;
    height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &--open {
      width: 57px;
    }
  }

  &__content {
    overflow: auto;
    list-style-type: none;
    font-weight: 500;
    font-size: 1.125rem;
    background-color: map-get($colors, 'dark-blue');
    height: 100%;
    padding-left: 0;
    padding-top: 0;
    text-align: center;

    &--open {
      width: 50px;
    }
  }

  &--open {
    min-width: 30%;
    max-width: 30%;
    z-index: 999 !important;
  }
}
</style>
